import { useTranslation } from '@shared/core';
import { FabButton, Flex } from '@withjoy/joykit';
import React from 'react';

type BottomActionProps = {
  onCancel: () => void;
  onSave: () => void;
  isLoading?: boolean;
  isSingleComponent?: boolean;
  isSaveDisabled?: boolean;
  cancelCtaText?: string;
  saveCtaText?: string;
};

export const BottomActions: React.FC<BottomActionProps> = ({ onCancel, onSave, isLoading, isSingleComponent, isSaveDisabled, cancelCtaText, saveCtaText }) => {
  const { t } = useTranslation('websiteEditor');
  const { save, cancel } = t('customPage');

  return (
    <Flex
      gap={6}
      width="100%"
      marginTop={isSingleComponent ? 7 : 0}
      paddingBottom={6}
      position={isSingleComponent ? 'initial' : 'absolute'}
      bottom={0}
      left={0}
      right={0}
      paddingTop={6}
      paddingLeft={[6, 8]}
      paddingRight={[6, 8]}
      background="linear-gradient(180deg, rgba(255, 255, 255, 0) 0, #FFF 100%);"
    >
      {!isSingleComponent && (
        <FabButton
          width="100%"
          variant="outline"
          style={{ filter: 'none' }}
          onClick={onCancel}
        >
          {cancelCtaText || cancel()}
        </FabButton>
      )}
      <FabButton
        background="black"
        width="100%"
        variant="solid"
        loading={isLoading}
        disabled={isLoading || isSaveDisabled}
        onClick={onSave}
      >
        {saveCtaText || save()}
      </FabButton>
    </Flex>
  );
};
